import * as teamsReducer from '../reducers/teams';

export const editing = (state) => {
  const ui = state.ui.network.teams;

  if (!ui.editing) return undefined;

  return teamsReducer.findById(state, ui.editing);
};
